import { Col, Row, Stack } from "react-bootstrap";
import { mapItemType, mapItemTypeColor } from "../HelperFunctions";
import moment from "moment/min/moment-with-locales";
import RATooltip from "../RATooltip";

export default function MinuteByMinuteRow({ item, virtualizer, virtualRow, setCatalogueSong, hourSeparator = false }) {
    return (
        <Row
            data-index={virtualRow?.index}
            ref={virtualizer?.measureElement}
            style={{ transform: `translateY(${virtualRow?.start - virtualizer?.options.scrollMargin}px)` }}
            className={`py-1 border-bottom ${virtualizer && "position-absolute"} w-100 hoverable ${hourSeparator && "border-2 border-black"}`}
            onClick={() => setCatalogueSong(item)}>
            <RATooltip
                className="item-type-bar p-0 rounded-1 align-self-stretch"
                style={{ borderLeftColor: mapItemTypeColor(item.item_type) }}
                tooltipElement={<Col xs={"auto"}></Col>}>
                {mapItemType(item.item_type)}
            </RATooltip>
            <Col>
                <Row>
                    <Col xs={12} xl={3} className=" align-content-center">
                        <Stack direction="horizontal" gap={1}>
                            <span>{moment(item.played_at).format("L")}</span>
                            <span className="fw-bold">{moment(item.played_at).format("LTS")}</span>
                        </Stack>
                    </Col>
                    <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                        {item.artist}
                    </Col>
                    <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                        {item.title}
                    </Col>
                    <Col xs={12} className=" align-content-center d-xl-none">
                        {item.artist} - {item.title} ({item.release_year})
                    </Col>
                    <Col xs={2} xl={2} className=" align-content-center text-center d-none d-xl-block">
                        {item.release_year}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
